var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconViceCaptain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3FEFF0EE-8342-424C-B2E8-92A30C7A366E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MFL---My-Team---Create-a-Team-(Select-a-captain)-[D]-",
    transform: "translate(-719.000000, -1102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Team-/-Field-View",
    transform: "translate(120.000000, 435.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.0-Components-/-Field-/-BKG-[D]",
    transform: "translate(20.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 13.060649)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.000000, 584.939351)",
    id: "Key"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(536.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Icon-/-Doubtful-Copy-2",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C3.584,0 0,3.584 0,8 C0,12.416 3.584,16 8,16 C12.416,16 16,12.416 16,8 C16,3.584 12.416,0 8,0 Z",
    id: "Path-Copy",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V",
    transform: "translate(4.000000, 4.000000)",
    fill: "#000151",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1.35336641,0 C1.49888968,0 1.6173872,0.0344859382 1.70885897,0.103457815 C1.80033073,0.172429691 1.86893456,0.261687414 1.91467045,0.371230982 L4.03515237,5.73886584 C4.10583511,5.91332411 4.17339948,6.10502536 4.2378455,6.31396957 C4.30229152,6.52291379 4.36361918,6.74301521 4.42182849,6.97427386 C4.51745807,6.5076994 4.63595559,6.09589673 4.77732105,5.73886584 L6.89156627,0.371230982 C6.92898653,0.27791609 6.99551146,0.192715537 7.09114103,0.115629322 C7.18677061,0.0385431074 7.30526813,0 7.44663359,0 L8.8,0 L5.15776045,8.8 L3.64223955,8.8 L0,0 Z",
    id: "Path"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViceCaptain);
export default __webpack_public_path__ + "static/media/IconViceCaptain.6579ba368cc760273c7955f086c2216d.svg";
export { ForwardRef as ReactComponent };